/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalAdminWhitelabelResponseV4FromJSON, InternalAdminWhitelabelResponseV4ToJSON, } from './InternalAdminWhitelabelResponseV4';
/**
 * Check if a given object implements the ListNetworkWhitelabels200Response interface.
 */
export function instanceOfListNetworkWhitelabels200Response(value) {
    if (!('cloudflareIps' in value) || value['cloudflareIps'] === undefined)
        return false;
    if (!('whitelabels' in value) || value['whitelabels'] === undefined)
        return false;
    return true;
}
export function ListNetworkWhitelabels200ResponseFromJSON(json) {
    return ListNetworkWhitelabels200ResponseFromJSONTyped(json, false);
}
export function ListNetworkWhitelabels200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cloudflareIps': json['cloudflare_ips'],
        'whitelabels': (json['whitelabels'].map(InternalAdminWhitelabelResponseV4FromJSON)),
    };
}
export function ListNetworkWhitelabels200ResponseToJSON(json) {
    return ListNetworkWhitelabels200ResponseToJSONTyped(json, false);
}
export function ListNetworkWhitelabels200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cloudflare_ips': value['cloudflareIps'],
        'whitelabels': (value['whitelabels'].map(InternalAdminWhitelabelResponseV4ToJSON)),
    };
}
